import { NAV, SITE } from "../../content";
import { onAnchor } from "../../lib/scroll";

const Legal = ({ href, label, testid }) => (
  <a href={href} data-testid={testid} className="text-slate-300 hover:text-white">{label}</a>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-navy-900 pb-28 pt-20 text-white md:pb-10">
    <div className="mx-auto grid max-w-[1400px] gap-12 px-5 sm:px-8 md:grid-cols-12 lg:px-12">
      <div className="md:col-span-5">
        <img src="/images/manta-logo.png" alt="Schwimmschule Manta" width="436" height="136" loading="lazy" className="h-12 w-auto" />
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-300">
          Schwimmkurse für Kinder in Dieburg, Darmstadt und Umgebung – von der Wassergewöhnung bis zum Schwimmabzeichen in Bronze.
        </p>
      </div>
      <nav aria-label="Footer-Navigation" className="md:col-span-3">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-sky-300">Navigation</p>
        <ul className="mt-5 space-y-2.5 text-sm">
          {NAV.map((n) => (
            <li key={n.id}>
              <a href={`/#${n.id}`} onClick={onAnchor(n.id)} data-testid={`footer-nav-${n.id}`} className="text-slate-300 hover:text-white">{n.label}</a>
            </li>
          ))}
          <li><a href="/schwimmkurse-dieburg" data-testid="footer-dieburg" className="text-slate-300 hover:text-white">Schwimmkurse Dieburg</a></li>
          <li><a href={SITE.parentAppUrl} data-testid="footer-elternbereich" className="text-slate-300 hover:text-white">App Login</a></li>
        </ul>
      </nav>
      <div className="md:col-span-4">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-sky-300">Kontakt & Rechtliches</p>
        <ul className="mt-5 space-y-2.5 text-sm">
          <li><a href={`mailto:${SITE.email}`} data-testid="footer-email" className="text-slate-300 hover:text-white">{SITE.email}</a></li>
          <li><a href={SITE.url} className="text-slate-300 hover:text-white">schwimmschulemanta.de</a></li>
          <li className="pt-3"><Legal href={SITE.impressumUrl} label="Impressum" testid="footer-impressum" /></li>
          <li><Legal href={SITE.datenschutzUrl} label="Datenschutzerklärung" testid="footer-datenschutz" /></li>
          <li><Legal href={SITE.agbUrl} label="AGB" testid="footer-agb" /></li>
        </ul>
      </div>
    </div>
    <div className="mx-auto mt-16 flex max-w-[1400px] flex-col gap-2 border-t border-white/10 px-5 pt-8 text-xs text-slate-400 sm:flex-row sm:justify-between sm:px-8 lg:px-12">
      <p>© {new Date().getFullYear()} Schwimmschule Manta</p>
    </div>
  </footer>
);
